import React, { useContext, useRef, useEffect, useState } from 'react';
import classnames from 'classnames';
import ReactDOM from 'react-dom';

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

var normalizeAlign = function normalizeAlign(align) {
  var map = {
    justify: 'justifyed',
    center: 'centered'
  };
  return align ? map[align] : '';
};

var normalizeStatus = function normalizeStatus(status) {
  var map = {
    focus: 'focused',
    hover: 'hovered',
    active: 'active'
  }; // return map[status] || status;

  return status ? map[status] : '';
};

var _excluded = ["textColor", "backgroundColor", "colorVariant", "flexDirection", "flexWrap", "justifyContent", "alignContent", "alignItems", "flexGrow", "ratio", "clearfix", "paddingless", "pull", "marginless", "overlay", "clipped", "radiusless", "shadowless", "unselectable", "invisible", "clickable", "srOnly", "display", "m", "mt", "mr", "mb", "ml", "mx", "my", "p", "pt", "pr", "pb", "pl", "px", "py", "textWeight", "textTransform", "italic", "textSize", "textAlign", "textFamily", "mobile", "tablet", "desktop", "widescreen", "fullhd", "touch", "untilWidescreen", "untilFullhd"],
    _excluded2 = ["className", "renderAs", "domRef", "children"];

var buildResponsiveness = function buildResponsiveness(currentViewport, _temp) {
  var _classnames;

  var _ref = _temp === void 0 ? {} : _temp,
      display = _ref.display,
      _ref$textAlign = _ref.textAlign,
      textAlign = _ref$textAlign === void 0 ? null : _ref$textAlign,
      textSize = _ref.textSize,
      only = _ref.only,
      invisible = _ref.invisible;

  var suffix = only ? '-only' : '';
  return classnames((_classnames = {}, _classnames["is-" + display + "-" + currentViewport + suffix] = display, _classnames["has-text-" + normalizeAlign(textAlign) + "-" + currentViewport + suffix] = textAlign, _classnames["is-size-" + textSize + "-" + currentViewport + suffix] = textSize, _classnames["is-invisible-" + currentViewport + suffix] = invisible, _classnames));
};

var useElementClassNames = function useElementClassNames(_ref2) {
  var _classnames2;

  var textColor = _ref2.textColor,
      backgroundColor = _ref2.backgroundColor,
      colorVariant = _ref2.colorVariant,
      flexDirection = _ref2.flexDirection,
      flexWrap = _ref2.flexWrap,
      justifyContent = _ref2.justifyContent,
      alignContent = _ref2.alignContent,
      alignItems = _ref2.alignItems,
      flexGrow = _ref2.flexGrow,
      clearfix = _ref2.clearfix,
      paddingless = _ref2.paddingless,
      pull = _ref2.pull,
      marginless = _ref2.marginless,
      overlay = _ref2.overlay,
      clipped = _ref2.clipped,
      radiusless = _ref2.radiusless,
      shadowless = _ref2.shadowless,
      unselectable = _ref2.unselectable,
      invisible = _ref2.invisible,
      clickable = _ref2.clickable,
      srOnly = _ref2.srOnly,
      display = _ref2.display,
      m = _ref2.m,
      mt = _ref2.mt,
      mr = _ref2.mr,
      mb = _ref2.mb,
      ml = _ref2.ml,
      mx = _ref2.mx,
      my = _ref2.my,
      p = _ref2.p,
      pt = _ref2.pt,
      pr = _ref2.pr,
      pb = _ref2.pb,
      pl = _ref2.pl,
      px = _ref2.px,
      py = _ref2.py,
      textWeight = _ref2.textWeight,
      textTransform = _ref2.textTransform,
      italic = _ref2.italic,
      textSize = _ref2.textSize,
      _ref2$textAlign = _ref2.textAlign,
      textAlign = _ref2$textAlign === void 0 ? null : _ref2$textAlign,
      textFamily = _ref2.textFamily,
      mobile = _ref2.mobile,
      tablet = _ref2.tablet,
      desktop = _ref2.desktop,
      widescreen = _ref2.widescreen,
      fullhd = _ref2.fullhd,
      touch = _ref2.touch,
      untilWidescreen = _ref2.untilWidescreen,
      untilFullhd = _ref2.untilFullhd,
      props = _objectWithoutPropertiesLoose(_ref2, _excluded);

  return [classnames((_classnames2 = {}, _classnames2["has-text-" + textColor] = textColor, _classnames2["has-background-" + backgroundColor] = backgroundColor, _classnames2["is-" + colorVariant] = colorVariant, _classnames2["is-flex-direction-" + flexDirection] = flexDirection, _classnames2["is-flex-wrap-" + flexWrap] = flexWrap, _classnames2["is-justify-content-" + justifyContent] = justifyContent, _classnames2["is-align-content-" + alignContent] = alignContent, _classnames2["is-align-items-" + alignItems] = alignItems, _classnames2["is-flex-grow-" + flexGrow] = flexGrow, _classnames2['is-clearfix'] = clearfix, _classnames2["is-pulled-" + pull] = pull, _classnames2['is-marginless'] = marginless, _classnames2['is-paddingless'] = paddingless, _classnames2['is-overlay'] = overlay, _classnames2['is-clipped'] = clipped, _classnames2['is-radiusless'] = radiusless, _classnames2['is-shadowless'] = shadowless, _classnames2['is-unselectable'] = unselectable, _classnames2["is-" + display] = display, _classnames2['is-invisible'] = invisible, _classnames2['is-sr-only'] = srOnly, _classnames2['is-clickable'] = clickable, _classnames2["m-" + m] = m, _classnames2["mt-" + mt] = mt, _classnames2["mr-" + mr] = mr, _classnames2["mb-" + mb] = mb, _classnames2["ml-" + ml] = ml, _classnames2["mx-" + mx] = mx, _classnames2["my-" + my] = my, _classnames2["p-" + p] = p, _classnames2["pt-" + pt] = pt, _classnames2["pr-" + pr] = pr, _classnames2["pb-" + pb] = pb, _classnames2["pl-" + pl] = pl, _classnames2["px-" + px] = px, _classnames2["py-" + py] = py, _classnames2["has-text-" + normalizeAlign(textAlign)] = textAlign, _classnames2["has-text-weight-" + textWeight] = textWeight, _classnames2["is-size-" + textSize] = textSize, _classnames2["is-" + textTransform] = textTransform, _classnames2["is-family-" + textFamily] = textFamily, _classnames2['is-italic'] = italic, _classnames2), buildResponsiveness('mobile', mobile), buildResponsiveness('tablet', tablet), buildResponsiveness('desktop', desktop), buildResponsiveness('widescreen', widescreen), buildResponsiveness('fullhd', fullhd), buildResponsiveness('touch', touch), buildResponsiveness('until-widescreen', untilWidescreen), buildResponsiveness('until-fullhd', untilFullhd)), props];
};

var Element = function Element(_ref3) {
  var className = _ref3.className,
      renderAs = _ref3.renderAs,
      domRef = _ref3.domRef,
      children = _ref3.children,
      allProps = _objectWithoutPropertiesLoose(_ref3, _excluded2);

  var RenderAsElement = renderAs || 'div';

  var _useElementClassNames = useElementClassNames(allProps),
      classNames = _useElementClassNames[0],
      props = _useElementClassNames[1];

  return React.createElement(RenderAsElement, Object.assign({
    ref: domRef,
    className: classnames(className, classNames) || undefined
  }, props), children);
};

var FieldContext = /*#__PURE__*/React.createContext({
  size: undefined
});

var useFieldContext = function useFieldContext() {
  return useContext(FieldContext);
};

var _excluded$1 = ["className", "size"];

var FieldLabel = function FieldLabel(_ref) {
  var _classnames;

  var className = _ref.className,
      size = _ref.size,
      props = _objectWithoutPropertiesLoose(_ref, _excluded$1);

  var context = useFieldContext();
  return React.createElement(Element, Object.assign({}, props, {
    className: classnames('field-label', className, (_classnames = {}, _classnames["is-" + size] = size || context.size, _classnames))
  }));
};

var _excluded$2 = ["children", "className"];

var FieldBody = function FieldBody(_ref) {
  var children = _ref.children,
      className = _ref.className,
      props = _objectWithoutPropertiesLoose(_ref, _excluded$2);

  return React.createElement(Element, Object.assign({}, props, {
    className: classnames('field-body', className, {})
  }), children);
};

var _excluded$3 = ["className", "align", "multiline", "horizontal", "kind", "size"];

var Field = function Field(_ref) {
  var _classnames;

  var className = _ref.className,
      align = _ref.align,
      multiline = _ref.multiline,
      horizontal = _ref.horizontal,
      kind = _ref.kind,
      size = _ref.size,
      props = _objectWithoutPropertiesLoose(_ref, _excluded$3);

  var context = useFieldContext();
  var k = null;

  if (kind === 'addons') {
    k = 'has-addons';
  } else if (kind === 'group') {
    k = 'is-grouped';
  }

  return React.createElement(FieldContext.Provider, {
    value: {
      size: size || context.size
    }
  }, React.createElement(Element, Object.assign({}, props, {
    className: classnames('field', className, (_classnames = {}, _classnames["" + k] = k, _classnames[k + "-" + normalizeAlign(align)] = k === 'is-grouped' && align, _classnames[k + "-multiline"] = k === 'is-grouped' && multiline, _classnames['is-horizontal'] = horizontal, _classnames))
  })));
};

Field.Label = FieldLabel;
Field.Body = FieldBody;
var _excluded$4 = ["className", "style", "disabled", "children", "checked", "domRef", "renderAs"];

var CheckBox = function CheckBox(_ref) {
  var className = _ref.className,
      style = _ref.style,
      disabled = _ref.disabled,
      children = _ref.children,
      domRef = _ref.domRef,
      _ref$renderAs = _ref.renderAs,
      renderAs = _ref$renderAs === void 0 ? 'input' : _ref$renderAs,
      props = _objectWithoutPropertiesLoose(_ref, _excluded$4);

  return React.createElement(Element, {
    renderAs: "label",
    domRef: domRef,
    disabled: disabled,
    className: classnames('checkbox', className),
    style: style
  }, React.createElement(Element, Object.assign({}, props, {
    renderAs: renderAs,
    type: "checkbox",
    disabled: disabled
  })), ' ', children);
};

var _excluded$5 = ["children", "className", "fullWidth", "loading", "iconType"];

var Control = function Control(_ref) {
  var children = _ref.children,
      className = _ref.className,
      fullWidth = _ref.fullWidth,
      loading = _ref.loading,
      iconType = _ref.iconType,
      props = _objectWithoutPropertiesLoose(_ref, _excluded$5);

  var context = useFieldContext();

  var isIcon = function isIcon(child) {
    return child.type === (iconType || Icon) && (child.props.align === 'left' || child.props.align === 'right');
  };

  var updatedChildren = React.Children.map(children, function (child) {
    if (!isIcon(child) && child.type !== Button) {
      return child;
    }

    return React.cloneElement(child, {
      size: child.props.size || context.size
    });
  });
  var icons = React.Children.toArray(updatedChildren).filter(isIcon).reduce(function (acc, icon) {
    return {
      iconLeft: acc.iconLeft || icon.props.align === 'left',
      iconRight: acc.iconRight || icon.props.align === 'right'
    };
  }, {
    iconLeft: false,
    iconRight: false
  });
  return React.createElement(Element, Object.assign({}, props, {
    className: classnames('control', className, {
      'is-expanded': fullWidth,
      'has-icons-left': icons && icons.iconLeft,
      'has-icons-right': icons && icons.iconRight,
      'is-loading': loading
    })
  }), updatedChildren);
};

var _excluded$6 = ["className", "children", "color"];

var Help = function Help(_ref) {
  var _classnames;

  var className = _ref.className,
      children = _ref.children,
      color = _ref.color,
      props = _objectWithoutPropertiesLoose(_ref, _excluded$6);

  return React.createElement(Element, Object.assign({}, props, {
    className: classnames('help', className, (_classnames = {}, _classnames["is-" + color] = color, _classnames))
  }), children);
};

var _excluded$7 = ["className", "size", "color", "readOnly", "isStatic", "status", "rounded", "renderAs"];

var Input = function Input(_ref) {
  var _classnames;

  var className = _ref.className,
      size = _ref.size,
      color = _ref.color,
      readOnly = _ref.readOnly,
      isStatic = _ref.isStatic,
      status = _ref.status,
      rounded = _ref.rounded,
      _ref$renderAs = _ref.renderAs,
      renderAs = _ref$renderAs === void 0 ? 'input' : _ref$renderAs,
      props = _objectWithoutPropertiesLoose(_ref, _excluded$7);

  var context = useFieldContext();
  var calculatedSize = size || context.size;
  return React.createElement(Element, Object.assign({}, props, {
    renderAs: renderAs,
    readOnly: readOnly || isStatic,
    className: classnames('input', className, (_classnames = {
      'is-static': isStatic
    }, _classnames["is-" + normalizeStatus(status)] = status, _classnames['is-rounded'] = rounded, _classnames["is-" + calculatedSize] = calculatedSize, _classnames["is-" + color] = color, _classnames))
  }));
};

var _excluded$8 = ["className", "style", "onChange", "color", "size", "fullWidth", "align", "boxed", "name", "label", "icon", "inputProps", "filename", "value"];

var InputFile = function InputFile(_ref) {
  var _classnames;

  var className = _ref.className,
      style = _ref.style,
      onChange = _ref.onChange,
      color = _ref.color,
      size = _ref.size,
      fullWidth = _ref.fullWidth,
      align = _ref.align,
      boxed = _ref.boxed,
      name = _ref.name,
      label = _ref.label,
      icon = _ref.icon,
      inputProps = _ref.inputProps,
      filename = _ref.filename,
      value = _ref.value,
      props = _objectWithoutPropertiesLoose(_ref, _excluded$8);

  var ref = useRef();
  var context = useFieldContext();
  var calculatedSize = size || context.size;
  useEffect(function () {
    if (!ref.current) {
      return;
    }

    if (value) {
      ref.current.files = value;
    } else {
      ref.current.value = '';
    }
  }, [value]);
  return React.createElement(Element, Object.assign({
    style: style
  }, props, {
    className: classnames('file', className, (_classnames = {}, _classnames["is-" + calculatedSize] = calculatedSize, _classnames["is-" + color] = color, _classnames["is-" + normalizeAlign(align)] = align, _classnames['has-name'] = !!filename, _classnames['is-boxed'] = boxed, _classnames['is-fullwidth'] = fullWidth, _classnames))
  }), React.createElement("label", {
    className: "file-label"
  }, React.createElement("input", Object.assign({}, inputProps, {
    name: name,
    type: "file",
    className: "file-input",
    onChange: onChange,
    ref: ref
  })), React.createElement("span", {
    className: "file-cta"
  }, icon && React.createElement("span", {
    className: "file-icon"
  }, icon), React.createElement("span", {
    className: "file-label"
  }, label)), filename && React.createElement("span", {
    className: "file-name"
  }, filename)));
};

var _excluded$9 = ["children", "className", "size"];

var Label = function Label(_ref) {
  var _classnames;

  var children = _ref.children,
      className = _ref.className,
      size = _ref.size,
      props = _objectWithoutPropertiesLoose(_ref, _excluded$9);

  var context = useFieldContext();
  var calculatedSize = size || context.size;
  return React.createElement(Element, Object.assign({}, props, {
    className: classnames('label', className, (_classnames = {}, _classnames["is-" + calculatedSize] = calculatedSize, _classnames))
  }), children);
};

var _excluded$a = ["className", "style", "disabled", "checked", "value", "name", "children", "domRef", "renderAs"];

var Radio = function Radio(_ref) {
  var className = _ref.className,
      style = _ref.style,
      disabled = _ref.disabled,
      checked = _ref.checked,
      value = _ref.value,
      name = _ref.name,
      children = _ref.children,
      domRef = _ref.domRef,
      _ref$renderAs = _ref.renderAs,
      renderAs = _ref$renderAs === void 0 ? 'input' : _ref$renderAs,
      props = _objectWithoutPropertiesLoose(_ref, _excluded$a);

  return React.createElement(Element, {
    renderAs: "label",
    domRef: domRef,
    disabled: disabled,
    className: classnames('radio', className),
    style: style
  }, React.createElement(Element, Object.assign({}, props, {
    name: name,
    checked: checked,
    type: "radio",
    value: value,
    disabled: disabled,
    renderAs: renderAs
  })), ' ', children);
};

var _excluded$b = ["className", "rounded", "style", "size", "color", "loading", "status", "disabled", "value", "multiple", "children", "name", "domRef"];

var Select = function Select(_ref) {
  var _classnames, _classnames2;

  var className = _ref.className,
      rounded = _ref.rounded,
      style = _ref.style,
      size = _ref.size,
      color = _ref.color,
      loading = _ref.loading,
      status = _ref.status,
      disabled = _ref.disabled,
      value = _ref.value,
      multiple = _ref.multiple,
      children = _ref.children,
      name = _ref.name,
      domRef = _ref.domRef,
      props = _objectWithoutPropertiesLoose(_ref, _excluded$b);
  /**
   * Return default value for value prop
   */


  var defaultValue = multiple ? [] : '';
  var context = useFieldContext();
  var calculatedSize = size || context.size;
  return React.createElement(Element, {
    domRef: domRef,
    className: classnames('select', className, (_classnames = {}, _classnames["is-" + calculatedSize] = calculatedSize, _classnames["is-" + color] = color, _classnames['is-loading'] = loading, _classnames['is-multiple'] = multiple, _classnames['is-rounded'] = rounded, _classnames)),
    style: style
  }, React.createElement(Element, Object.assign({}, props, {
    className: classnames((_classnames2 = {}, _classnames2["is-" + normalizeStatus(status)] = status, _classnames2)),
    renderAs: "select",
    multiple: multiple,
    value: value !== undefined ? value : defaultValue,
    disabled: disabled,
    name: name
  }), children));
};

var _excluded$c = ["className", "size", "color", "status", "fixedSize"];

var TextArea = function TextArea(_ref) {
  var _classnames;

  var className = _ref.className,
      size = _ref.size,
      color = _ref.color,
      status = _ref.status,
      fixedSize = _ref.fixedSize,
      props = _objectWithoutPropertiesLoose(_ref, _excluded$c);

  var context = useFieldContext();
  var calculatedSize = size || context.size;
  return React.createElement(Element, Object.assign({}, props, {
    className: classnames('textarea', className, (_classnames = {}, _classnames["is-" + normalizeStatus(status)] = status, _classnames['has-fixed-size'] = fixedSize, _classnames["is-" + calculatedSize] = calculatedSize, _classnames["is-" + color] = color, _classnames))
  }));
};

var index = {
  __proto__: null,
  Field: Field,
  CheckBox: CheckBox,
  Control: Control,
  Help: Help,
  Input: Input,
  InputFile: InputFile,
  Label: Label,
  Radio: Radio,
  Select: Select,
  TextArea: TextArea
};
var _excluded$d = ["children", "className"];

var Box = function Box(_ref) {
  var children = _ref.children,
      className = _ref.className,
      props = _objectWithoutPropertiesLoose(_ref, _excluded$d);

  return React.createElement(Element, Object.assign({}, props, {
    className: classnames('box', className)
  }), children);
};

var _excluded$e = ["children", "max", "breakpoint", "className"];

var Container = function Container(_ref) {
  var _classnames;

  var children = _ref.children,
      max = _ref.max,
      _ref$breakpoint = _ref.breakpoint,
      breakpoint = _ref$breakpoint === void 0 ? '' : _ref$breakpoint,
      className = _ref.className,
      props = _objectWithoutPropertiesLoose(_ref, _excluded$e);

  var canSetMax = ['desktop', 'widescreen'].includes(breakpoint);
  return React.createElement(Element, Object.assign({}, props, {
    className: classnames('container', className, (_classnames = {}, _classnames["is-" + (canSetMax && max ? 'max-' : '') + breakpoint] = breakpoint, _classnames))
  }), children);
};

var _excluded$f = ["className", "align"];

var LevelSide = function LevelSide(_ref) {
  var _classnames;

  var className = _ref.className,
      _ref$align = _ref.align,
      align = _ref$align === void 0 ? 'left' : _ref$align,
      props = _objectWithoutPropertiesLoose(_ref, _excluded$f);

  return React.createElement(Element, Object.assign({}, props, {
    className: classnames(className, (_classnames = {}, _classnames["level-" + align] = align, _classnames))
  }));
};

var _excluded$g = ["children", "className"];

var LevelItem = function LevelItem(_ref) {
  var children = _ref.children,
      className = _ref.className,
      props = _objectWithoutPropertiesLoose(_ref, _excluded$g);

  return React.createElement(Element, Object.assign({}, props, {
    className: classnames('level-item', className, {})
  }), children);
};

var _excluded$h = ["children", "className", "breakpoint"];

var Level = function Level(_ref) {
  var _classnames;

  var children = _ref.children,
      className = _ref.className,
      breakpoint = _ref.breakpoint,
      props = _objectWithoutPropertiesLoose(_ref, _excluded$h);

  return React.createElement(Element, Object.assign({}, props, {
    className: classnames('level', className, (_classnames = {}, _classnames["is-" + breakpoint] = breakpoint, _classnames))
  }), children);
};

Level.Side = LevelSide;
Level.Item = LevelItem;
var _excluded$i = ["children", "className", "align"];

var MediaItem = function MediaItem(_ref) {
  var _classnames;

  var children = _ref.children,
      className = _ref.className,
      _ref$align = _ref.align,
      align = _ref$align === void 0 ? 'center' : _ref$align,
      props = _objectWithoutPropertiesLoose(_ref, _excluded$i);

  var p = align === 'center' ? 'content' : align;
  return React.createElement(Element, Object.assign({}, props, {
    className: classnames(className, (_classnames = {}, _classnames["media-" + p] = p, _classnames))
  }), children);
};

var _excluded$j = ["children", "renderAs", "className"];

var Media = function Media(_ref) {
  var children = _ref.children,
      _ref$renderAs = _ref.renderAs,
      renderAs = _ref$renderAs === void 0 ? 'article' : _ref$renderAs,
      className = _ref.className,
      props = _objectWithoutPropertiesLoose(_ref, _excluded$j);

  return React.createElement(Element, Object.assign({}, props, {
    renderAs: renderAs,
    className: classnames('media', className, {})
  }), children);
};

Media.Item = MediaItem;
var _excluded$k = ["className", "renderAs"];

var HeroHeader = function HeroHeader(_ref) {
  var className = _ref.className,
      props = _objectWithoutPropertiesLoose(_ref, _excluded$k);

  return React.createElement(Element, Object.assign({}, props, {
    className: classnames(className, 'hero-head')
  }));
};

var _excluded$l = ["className", "renderAs"];

var HeroBody = function HeroBody(_ref) {
  var className = _ref.className,
      props = _objectWithoutPropertiesLoose(_ref, _excluded$l);

  return React.createElement(Element, Object.assign({}, props, {
    className: classnames(className, 'hero-body')
  }));
};

var _excluded$m = ["className", "renderAs"];

var HeroFooter = function HeroFooter(_ref) {
  var className = _ref.className,
      props = _objectWithoutPropertiesLoose(_ref, _excluded$m);

  return React.createElement(Element, Object.assign({}, props, {
    className: classnames(className, 'hero-foot')
  }));
};

var _excluded$n = ["children", "className", "color", "gradient", "size", "hasNavbar", "renderAs"];

var Hero = function Hero(_ref) {
  var _classnames;

  var children = _ref.children,
      className = _ref.className,
      color = _ref.color,
      gradient = _ref.gradient,
      size = _ref.size,
      hasNavbar = _ref.hasNavbar,
      _ref$renderAs = _ref.renderAs,
      renderAs = _ref$renderAs === void 0 ? 'section' : _ref$renderAs,
      props = _objectWithoutPropertiesLoose(_ref, _excluded$n);

  return React.createElement(Element, Object.assign({}, props, {
    renderAs: renderAs,
    className: classnames('hero', className, (_classnames = {}, _classnames["is-" + color] = color, _classnames["is-" + size] = size && !hasNavbar, _classnames['is-bold'] = gradient, _classnames['is-fullheight-with-navbar'] = hasNavbar, _classnames))
  }), children);
};

Hero.Header = HeroHeader;
Hero.Body = HeroBody;
Hero.Footer = HeroFooter;
var _excluded$o = ["children", "className", "size"];

var Section = function Section(_ref) {
  var _classnames;

  var children = _ref.children,
      className = _ref.className,
      _ref$size = _ref.size,
      size = _ref$size === void 0 ? 'small' : _ref$size,
      props = _objectWithoutPropertiesLoose(_ref, _excluded$o);

  return React.createElement(Element, Object.assign({}, props, {
    className: classnames('section', className, (_classnames = {}, _classnames["is-" + size] = size, _classnames))
  }), children);
};

var _excluded$p = ["className"];

var Footer = function Footer(_ref) {
  var className = _ref.className,
      props = _objectWithoutPropertiesLoose(_ref, _excluded$p);

  return React.createElement(Element, Object.assign({}, props, {
    className: classnames('footer', className)
  }));
};

var _excluded$q = ["children", "className", "kind", "vertical", "size", "color"];

var Tile = function Tile(_ref) {
  var _classnames;

  var children = _ref.children,
      className = _ref.className,
      kind = _ref.kind,
      vertical = _ref.vertical,
      size = _ref.size,
      color = _ref.color,
      props = _objectWithoutPropertiesLoose(_ref, _excluded$q);

  return React.createElement(Element, Object.assign({}, props, {
    className: classnames('tile', className, (_classnames = {}, _classnames["is-" + kind] = kind, _classnames["is-" + size] = size, _classnames["is-" + color] = color, _classnames['is-vertical'] = vertical, _classnames))
  }), children);
};

var _excluded$r = ["children", "className", "size", "offset", "narrow", "mobile", "tablet", "desktop", "widescreen", "fullhd", "touch"];

var Column = function Column(_ref) {
  var _classnames;

  var children = _ref.children,
      className = _ref.className,
      size = _ref.size,
      offset = _ref.offset,
      narrow = _ref.narrow,
      _ref$mobile = _ref.mobile,
      mobile = _ref$mobile === void 0 ? {} : _ref$mobile,
      _ref$tablet = _ref.tablet,
      tablet = _ref$tablet === void 0 ? {} : _ref$tablet,
      _ref$desktop = _ref.desktop,
      desktop = _ref$desktop === void 0 ? {} : _ref$desktop,
      _ref$widescreen = _ref.widescreen,
      widescreen = _ref$widescreen === void 0 ? {} : _ref$widescreen,
      _ref$fullhd = _ref.fullhd,
      fullhd = _ref$fullhd === void 0 ? {} : _ref$fullhd,
      _ref$touch = _ref.touch,
      touch = _ref$touch === void 0 ? {} : _ref$touch,
      props = _objectWithoutPropertiesLoose(_ref, _excluded$r);

  return React.createElement(Element, Object.assign({}, props, {
    mobile: mobile,
    tablet: tablet,
    desktop: desktop,
    widescreen: widescreen,
    fullhd: fullhd,
    touch: touch
  }, {
    className: classnames(className, 'column', (_classnames = {}, _classnames["is-" + size] = size, _classnames["is-" + touch.size + "-mobile"] = touch.size, _classnames["is-" + mobile.size + "-mobile"] = mobile.size, _classnames["is-" + tablet.size + "-tablet"] = tablet.size, _classnames["is-" + desktop.size + "-desktop"] = desktop.size, _classnames["is-" + widescreen.size + "-widescreen"] = widescreen.size, _classnames["is-" + fullhd.size + "-fullhd"] = fullhd.size, _classnames["is-offset-" + touch.offset + "-mobile"] = touch.offset, _classnames["is-offset-" + mobile.offset + "-mobile"] = mobile.offset, _classnames["is-offset-" + tablet.offset + "-tablet"] = tablet.offset, _classnames["is-offset-" + desktop.offset + "-desktop"] = desktop.offset, _classnames["is-offset-" + widescreen.offset + "-widescreen"] = widescreen.offset, _classnames["is-offset-" + fullhd.offset + "-fullhd"] = fullhd.offset, _classnames["is-offset-" + offset] = offset, _classnames['is-narrow'] = narrow, _classnames['is-narrow-touch'] = touch.narrow, _classnames['is-narrow-mobile'] = mobile.narrow, _classnames['is-narrow-tablet'] = tablet.narrow, _classnames['is-narrow-desktop'] = desktop.narrow, _classnames['is-narrow-widescreen'] = widescreen.narrow, _classnames['is-narrow-fullhd'] = fullhd.narrow, _classnames))
  }), children);
};

var COLUMN_CONSTANTS = {
  SIZES: {
    THREEQUARTERS: 'three-quarters',
    TWOTHIRDS: 'two-thirds',
    HALF: 'half',
    ONETHIRD: 'one-third',
    ONEQUARTER: 'one-quarter',
    ONEFIFTH: 'one-fifth',
    TWOFIFTHS: 'two-fifths',
    THREEFIFTHS: 'three-fifths',
    FOURFIFTHS: 'four-fifths'
  }
};
var _excluded$s = ["className", "breakpoint", "gap", "multiline", "centered", "vCentered", "variableGap", "mobile", "tablet", "desktop", "widescreen", "fullhd", "touch"];

var Columns = function Columns(_ref) {
  var _classnames;

  var className = _ref.className,
      breakpoint = _ref.breakpoint,
      gap = _ref.gap,
      _ref$multiline = _ref.multiline,
      multiline = _ref$multiline === void 0 ? true : _ref$multiline,
      centered = _ref.centered,
      vCentered = _ref.vCentered,
      _ref$mobile = _ref.mobile,
      mobile = _ref$mobile === void 0 ? {} : _ref$mobile,
      _ref$tablet = _ref.tablet,
      tablet = _ref$tablet === void 0 ? {} : _ref$tablet,
      _ref$desktop = _ref.desktop,
      desktop = _ref$desktop === void 0 ? {} : _ref$desktop,
      _ref$widescreen = _ref.widescreen,
      widescreen = _ref$widescreen === void 0 ? {} : _ref$widescreen,
      _ref$fullhd = _ref.fullhd,
      fullhd = _ref$fullhd === void 0 ? {} : _ref$fullhd,
      _ref$touch = _ref.touch,
      touch = _ref$touch === void 0 ? {} : _ref$touch,
      props = _objectWithoutPropertiesLoose(_ref, _excluded$s);

  return React.createElement(Element, Object.assign({}, props, {
    mobile: mobile,
    tablet: tablet,
    desktop: desktop,
    widescreen: widescreen,
    fullhd: fullhd,
    touch: touch
  }, {
    className: classnames(className, 'columns', (_classnames = {}, _classnames["is-" + breakpoint] = breakpoint, _classnames["is-" + gap] = gap !== undefined, _classnames['is-multiline'] = multiline, _classnames['is-centered'] = centered, _classnames['is-vcentered'] = vCentered, _classnames['is-variable'] = gap !== undefined || [touch, mobile, tablet, desktop, widescreen, fullhd].find(function (b) {
      return b.gap !== undefined;
    }), _classnames["is-" + touch.gap + "-touch"] = touch.gap !== undefined, _classnames["is-" + mobile.gap + "-mobile"] = mobile.gap !== undefined, _classnames["is-" + tablet.gap + "-tablet"] = tablet.gap !== undefined, _classnames["is-" + desktop.gap + "-desktop"] = desktop.gap !== undefined, _classnames["is-" + widescreen.gap + "-widescreen"] = widescreen.gap !== undefined, _classnames["is-" + fullhd.gap + "-fullhd"] = fullhd.gap !== undefined, _classnames))
  }));
};

Columns.Column = Column;
Columns.CONSTANTS = COLUMN_CONSTANTS;
var _excluded$t = ["className"];

var Block = function Block(_ref) {
  var className = _ref.className,
      props = _objectWithoutPropertiesLoose(_ref, _excluded$t);

  return React.createElement(Element, Object.assign({}, props, {
    className: classnames('block', className)
  }));
};

var normalizeAlign$1 = function normalizeAlign(align) {
  var map = {
    justify: 'justifyed',
    center: 'centered'
  };
  return map[align] || align;
};

var normalizeStatus$1 = function normalizeStatus(status) {
  var map = {
    focus: 'focused',
    hover: 'hovered',
    active: 'active'
  };
  return map[status] || status;
};

var _excluded$u = ["className", "hasAddons", "align", "size", "renderAs"];

var ButtonGroup = function ButtonGroup(_ref) {
  var _classnames;

  var className = _ref.className,
      hasAddons = _ref.hasAddons,
      align = _ref.align,
      size = _ref.size,
      props = _objectWithoutPropertiesLoose(_ref, _excluded$u);

  return React.createElement(Element, Object.assign({}, props, {
    className: classnames('buttons', className, (_classnames = {
      'has-addons': hasAddons
    }, _classnames["is-" + [normalizeAlign$1(align)]] = align, _classnames["are-" + size] = size, _classnames))
  }));
};

var _excluded$v = ["children", "className", "renderAs", "href", "color", "size", "outlined", "inverted", "submit", "isLink", "reset", "fullwidth", "status", "loading", "disabled", "remove", "isSelected", "isStatic", "rounded", "onClick", "text"];

var Button = function Button(_ref) {
  var _classnames;

  var children = _ref.children,
      className = _ref.className,
      _ref$renderAs = _ref.renderAs,
      renderAs = _ref$renderAs === void 0 ? 'button' : _ref$renderAs,
      href = _ref.href,
      color = _ref.color,
      size = _ref.size,
      outlined = _ref.outlined,
      inverted = _ref.inverted,
      submit = _ref.submit,
      isLink = _ref.isLink,
      reset = _ref.reset,
      fullwidth = _ref.fullwidth,
      status = _ref.status,
      loading = _ref.loading,
      disabled = _ref.disabled,
      remove = _ref.remove,
      isSelected = _ref.isSelected,
      isStatic = _ref.isStatic,
      rounded = _ref.rounded,
      onClick = _ref.onClick,
      text = _ref.text,
      props = _objectWithoutPropertiesLoose(_ref, _excluded$v);

  var otherProps = {};

  if (isLink) {
    otherProps = {
      renderAs: 'a'
    };
  }

  if (submit) {
    otherProps = {
      type: 'submit',
      renderAs: 'button'
    };
  }

  if (reset) {
    otherProps = {
      type: 'reset',
      renderAs: 'button'
    };
  }

  if (isStatic) {
    otherProps = {
      renderAs: 'span'
    };
  }

  return React.createElement(Element, Object.assign({
    tabIndex: disabled ? -1 : 0,
    renderAs: renderAs,
    href: href
  }, props, otherProps, {
    disabled: disabled,
    onClick: disabled ? undefined : onClick,
    className: classnames(className, (_classnames = {}, _classnames["is-" + color] = color, _classnames["is-" + size] = size, _classnames['is-selected'] = isSelected, _classnames['is-static'] = isStatic, _classnames['is-rounded'] = rounded, _classnames['is-outlined'] = outlined, _classnames['is-inverted'] = inverted, _classnames['is-fullwidth'] = fullwidth, _classnames["is-" + normalizeStatus$1(status)] = status, _classnames['is-loading'] = loading, _classnames['is-text'] = text, _classnames["delete"] = remove, _classnames.button = !remove, _classnames))
  }), children);
};

Button.Group = ButtonGroup;
var _excluded$w = ["className", "color", "light"];

var Notification = function Notification(_ref) {
  var _classnames;

  var className = _ref.className,
      color = _ref.color,
      light = _ref.light,
      props = _objectWithoutPropertiesLoose(_ref, _excluded$w);

  return React.createElement(Element, Object.assign({}, props, {
    className: classnames('notification', (_classnames = {}, _classnames["is-" + color] = color, _classnames['is-light'] = light, _classnames), className)
  }));
};

var _excluded$x = ["className", "value", "max", "color", "size", "renderAs"];

var Progress = function Progress(_ref) {
  var _classnames;

  var className = _ref.className,
      value = _ref.value,
      max = _ref.max,
      color = _ref.color,
      size = _ref.size,
      props = _objectWithoutPropertiesLoose(_ref, _excluded$x);

  return React.createElement(Element, Object.assign({}, props, {
    value: value,
    max: max,
    className: classnames('progress', className, (_classnames = {}, _classnames["is-" + color] = color, _classnames["is-" + size] = size, _classnames))
  }));
};

var _excluded$y = ["children", "className"];

var ModalContent = function ModalContent(_ref) {
  var children = _ref.children,
      className = _ref.className,
      props = _objectWithoutPropertiesLoose(_ref, _excluded$y);

  return React.createElement(Element, Object.assign({}, props, {
    className: classnames('modal-content', className)
  }), children);
};

var ModalContext = /*#__PURE__*/React.createContext({
  onClose: function onClose() {}
});

var useModalContext = function useModalContext() {
  return useContext(ModalContext);
};

var _excluded$z = ["children", "className", "showClose", "renderAs"];

var ModalCardHead = function ModalCardHead(_ref) {
  var children = _ref.children,
      className = _ref.className,
      _ref$showClose = _ref.showClose,
      showClose = _ref$showClose === void 0 ? true : _ref$showClose,
      _ref$renderAs = _ref.renderAs,
      renderAs = _ref$renderAs === void 0 ? 'header' : _ref$renderAs,
      props = _objectWithoutPropertiesLoose(_ref, _excluded$z);

  var _useModalContext = useModalContext(),
      onClose = _useModalContext.onClose;

  return React.createElement(Element, Object.assign({}, props, {
    renderAs: renderAs,
    className: classnames('modal-card-head', className)
  }), children, showClose && React.createElement(Button, {
    remove: true,
    onClick: onClose
  }));
};

var _excluded$A = ["children", "className", "renderAs"];

var ModalCardBody = function ModalCardBody(_ref) {
  var children = _ref.children,
      className = _ref.className,
      _ref$renderAs = _ref.renderAs,
      renderAs = _ref$renderAs === void 0 ? 'section' : _ref$renderAs,
      props = _objectWithoutPropertiesLoose(_ref, _excluded$A);

  return React.createElement(Element, Object.assign({}, props, {
    renderAs: renderAs,
    className: classnames('modal-card-body', className)
  }), children);
};

var _excluded$B = ["children", "className", "renderAs"];

var ModalCardFoot = function ModalCardFoot(_ref) {
  var children = _ref.children,
      className = _ref.className,
      _ref$renderAs = _ref.renderAs,
      renderAs = _ref$renderAs === void 0 ? 'footer' : _ref$renderAs,
      props = _objectWithoutPropertiesLoose(_ref, _excluded$B);

  return React.createElement(Element, Object.assign({}, props, {
    renderAs: renderAs,
    className: classnames('modal-card-foot', className)
  }), children);
};

var _excluded$C = ["children", "renderAs", "className"];

var ModalCardTitle = function ModalCardTitle(_ref) {
  var children = _ref.children,
      _ref$renderAs = _ref.renderAs,
      renderAs = _ref$renderAs === void 0 ? 'p' : _ref$renderAs,
      className = _ref.className,
      props = _objectWithoutPropertiesLoose(_ref, _excluded$C);

  return React.createElement(Element, Object.assign({}, props, {
    renderAs: renderAs,
    className: classnames('modal-card-title', className)
  }), children);
};

var _excluded$D = ["className", "onClose", "children"];

var ModalCard = function ModalCard(_ref) {
  var className = _ref.className,
      children = _ref.children,
      props = _objectWithoutPropertiesLoose(_ref, _excluded$D);

  return React.createElement(Element, Object.assign({}, props, {
    className: classnames('modal-card', className)
  }), children);
};

ModalCard.Header = ModalCardHead;
ModalCard.Body = ModalCardBody;
ModalCard.Footer = ModalCardFoot;
ModalCard.Title = ModalCardTitle;
var _excluded$E = ["domRef", "children", "className", "show", "closeOnBlur", "onClose", "closeOnEsc", "showClose", "document"];
var KEYCODES = {
  ESCAPE: 27
};

var Modal = function Modal(_ref) {
  var domRef = _ref.domRef,
      children = _ref.children,
      className = _ref.className,
      show = _ref.show,
      closeOnBlur = _ref.closeOnBlur,
      onClose = _ref.onClose,
      _ref$closeOnEsc = _ref.closeOnEsc,
      closeOnEsc = _ref$closeOnEsc === void 0 ? true : _ref$closeOnEsc,
      _ref$showClose = _ref.showClose,
      showClose = _ref$showClose === void 0 ? true : _ref$showClose,
      document = _ref.document,
      props = _objectWithoutPropertiesLoose(_ref, _excluded$E);

  var ref = useRef(domRef);

  var _useState = useState(),
      portalContainer = _useState[0],
      setPortalContainer = _useState[1];

  useEffect(function () {
    if (!show) {
      return undefined;
    }

    var doc = document || window.document;
    var container = doc.createElement('div');
    container.setAttribute('class', 'modal-container');
    doc.body.appendChild(container);
    setPortalContainer(container);

    var handleKeydown = function handleKeydown(evt) {
      if (evt.keyCode === KEYCODES.ESCAPE && show) {
        onClose();
      }
    };

    if (closeOnEsc) {
      doc.addEventListener('keydown', handleKeydown);
    }

    return function () {
      doc.removeEventListener('keydown', handleKeydown);
      container.parentNode.removeChild(container);
    };
  }, [show]);

  if (!portalContainer) {
    return React.createElement(React.Fragment, null);
  }

  return ReactDOM.createPortal(React.createElement(ModalContext.Provider, {
    value: {
      onClose: onClose
    }
  }, React.createElement(Element, Object.assign({}, props, {
    domRef: ref,
    className: classnames('modal', className, {
      'is-active': show
    })
  }), React.createElement("div", {
    role: "presentation",
    className: "modal-background",
    onClick: closeOnBlur ? onClose : undefined
  }), children, showClose && React.createElement("button", {
    type: "button",
    onClick: onClose,
    className: "modal-close is-large",
    "aria-label": "close"
  }))), portalContainer);
};

Modal.Content = ModalContent;
Modal.Card = ModalCard;
var _excluded$F = ["children", "className"];

var MessageBody = function MessageBody(_ref) {
  var children = _ref.children,
      className = _ref.className,
      props = _objectWithoutPropertiesLoose(_ref, _excluded$F);

  return React.createElement(Element, Object.assign({}, props, {
    className: classnames('message-body', className)
  }), children);
};

var _excluded$G = ["children", "className"];

var MessageHeader = function MessageHeader(_ref) {
  var children = _ref.children,
      className = _ref.className,
      props = _objectWithoutPropertiesLoose(_ref, _excluded$G);

  return React.createElement(Element, Object.assign({}, props, {
    className: classnames('message-header', className)
  }), children);
};

var _excluded$H = ["children", "className", "color", "size", "renderAs"];

var Message = function Message(_ref) {
  var _classnames;

  var children = _ref.children,
      className = _ref.className,
      color = _ref.color,
      size = _ref.size,
      _ref$renderAs = _ref.renderAs,
      renderAs = _ref$renderAs === void 0 ? 'article' : _ref$renderAs,
      props = _objectWithoutPropertiesLoose(_ref, _excluded$H);

  return React.createElement(Element, Object.assign({
    renderAs: renderAs
  }, props, {
    className: classnames('message', className, (_classnames = {}, _classnames["is-" + color] = color, _classnames["is-" + size] = size, _classnames))
  }), children);
};

Message.Body = MessageBody;
Message.Header = MessageHeader;
var _excluded$I = ["className", "alt", "size", "fallback", "renderAs", "rounded", "src", "fullwidth"];

var Image = function Image(_ref) {
  var _classnames;

  var className = _ref.className,
      alt = _ref.alt,
      size = _ref.size,
      _ref$fallback = _ref.fallback,
      fallback = _ref$fallback === void 0 ? '' : _ref$fallback,
      _ref$renderAs = _ref.renderAs,
      renderAs = _ref$renderAs === void 0 ? 'figure' : _ref$renderAs,
      rounded = _ref.rounded,
      src = _ref.src,
      fullwidth = _ref.fullwidth,
      props = _objectWithoutPropertiesLoose(_ref, _excluded$I);

  var _useState = useState({
    src: src
  }),
      state = _useState[0],
      setState = _useState[1];

  useEffect(function () {
    setState({
      src: src
    });
  }, [src]);
  var s = size;

  if (typeof size === 'number') {
    s = s + "x" + s;
  }

  return React.createElement(Element, Object.assign({}, props, {
    renderAs: renderAs,
    className: classnames('image', className, (_classnames = {}, _classnames["is-" + s] = s, _classnames['is-fullwidth'] = fullwidth, _classnames))
  }), React.createElement("img", {
    className: classnames({
      'is-rounded': rounded
    }),
    onError: function onError() {
      return state.src !== fallback && setState({
        src: fallback
      });
    },
    src: state.src,
    alt: alt
  }));
};

var _excluded$J = ["className", "domRef"];

var CardImage = function CardImage(_ref) {
  var className = _ref.className,
      domRef = _ref.domRef,
      props = _objectWithoutPropertiesLoose(_ref, _excluded$J);

  return React.createElement(Element, Object.assign({}, props, {
    domRef: domRef,
    className: classnames('card-image', className)
  }), React.createElement(Image, Object.assign({}, props)));
};

var _excluded$K = ["className"];

var CardContent = function CardContent(_ref) {
  var className = _ref.className,
      props = _objectWithoutPropertiesLoose(_ref, _excluded$K);

  return React.createElement(Element, Object.assign({}, props, {
    className: classnames('card-content', className)
  }));
};

var _excluded$L = ["className"];

var CardHeaderTitle = function CardHeaderTitle(_ref) {
  var className = _ref.className,
      props = _objectWithoutPropertiesLoose(_ref, _excluded$L);

  return React.createElement(Element, Object.assign({}, props, {
    className: classnames('card-header-title', className)
  }));
};

var _excluded$M = ["className"];

var CardHeaderIcon = function CardHeaderIcon(_ref) {
  var className = _ref.className,
      props = _objectWithoutPropertiesLoose(_ref, _excluded$M);

  return React.createElement(Element, Object.assign({}, props, {
    className: classnames('card-header-icon', className)
  }));
};

var _excluded$N = ["className"];

var CardHeader = function CardHeader(_ref) {
  var className = _ref.className,
      props = _objectWithoutPropertiesLoose(_ref, _excluded$N);

  return React.createElement(Element, Object.assign({}, props, {
    className: classnames('card-header', className)
  }));
};

CardHeader.Title = CardHeaderTitle;
CardHeader.Icon = CardHeaderIcon;
var _excluded$O = ["className"];

var CardFooterItem = function CardFooterItem(_ref) {
  var className = _ref.className,
      props = _objectWithoutPropertiesLoose(_ref, _excluded$O);

  return React.createElement(Element, Object.assign({}, props, {
    className: classnames('card-footer-item', className)
  }));
};

var _excluded$P = ["className"];

var CardFooter = function CardFooter(_ref) {
  var className = _ref.className,
      props = _objectWithoutPropertiesLoose(_ref, _excluded$P);

  return React.createElement(Element, Object.assign({}, props, {
    className: classnames('card-footer', className)
  }));
};

CardFooter.Item = CardFooterItem;
var _excluded$Q = ["className", "children"];

var Card = function Card(_ref) {
  var className = _ref.className,
      children = _ref.children,
      props = _objectWithoutPropertiesLoose(_ref, _excluded$Q);

  return React.createElement(Element, Object.assign({
    className: classnames('card', className)
  }, props), children);
};

Card.Image = CardImage;
Card.Content = CardContent;
Card.Header = CardHeader;
Card.Footer = CardFooter;
var _excluded$R = ["children", "active", "className", "renderAs", "domRef"];

var MenuListItem = function MenuListItem(_ref) {
  var _React$Children$only;

  var children = _ref.children,
      active = _ref.active,
      className = _ref.className,
      _ref$renderAs = _ref.renderAs,
      renderAs = _ref$renderAs === void 0 ? 'a' : _ref$renderAs,
      ref = _ref.domRef,
      props = _objectWithoutPropertiesLoose(_ref, _excluded$R);

  if (typeof children !== 'string' && React.Children.toArray(children).length === 1 && ((_React$Children$only = React.Children.only(children)) == null ? void 0 : _React$Children$only.type) === MenuList) {
    var child = React.Children.only(children);
    return React.createElement("li", {
      "data-ref": ref
    }, React.createElement(Element, Object.assign({
      renderAs: renderAs,
      className: classnames(className, {
        'is-active': active
      })
    }, props), child.title), React.cloneElement(child, {
      title: undefined
    }));
  }

  return React.createElement("li", {
    "data-ref": ref
  }, React.createElement(Element, Object.assign({
    renderAs: renderAs,
    className: classnames(className, {
      'is-active': active
    })
  }, props), children));
};

var _excluded$S = ["className", "title", "renderAs"];

var MenuList = function MenuList(_ref) {
  var className = _ref.className,
      title = _ref.title,
      _ref$renderAs = _ref.renderAs,
      renderAs = _ref$renderAs === void 0 ? 'ul' : _ref$renderAs,
      props = _objectWithoutPropertiesLoose(_ref, _excluded$S);

  return React.createElement(React.Fragment, null, title && React.createElement("p", {
    className: "menu-label"
  }, title), React.createElement(Element, Object.assign({
    renderAs: renderAs,
    className: classnames('menu-list', className)
  }, props)));
};

MenuList.Item = MenuListItem;
var _excluded$T = ["className", "renderAs"];

var Menu = function Menu(_ref) {
  var className = _ref.className,
      _ref$renderAs = _ref.renderAs,
      renderAs = _ref$renderAs === void 0 ? 'aside' : _ref$renderAs,
      props = _objectWithoutPropertiesLoose(_ref, _excluded$T);

  return React.createElement(Element, Object.assign({}, props, {
    renderAs: renderAs,
    className: classnames('menu', className)
  }));
};

Menu.List = MenuList;
var _excluded$U = ["active", "children", "value", "className"];

var DropdownItem = function DropdownItem(_ref) {
  var active = _ref.active,
      children = _ref.children,
      value = _ref.value,
      className = _ref.className,
      props = _objectWithoutPropertiesLoose(_ref, _excluded$U);

  return React.createElement(Element, Object.assign({
    title: value
  }, props, {
    role: "presentation",
    className: classnames(className, 'dropdown-item', {
      'is-active': active
    })
  }), children);
};

var _excluded$V = ["className", "renderAs"];

var DropdownDivider = function DropdownDivider(_ref) {
  var className = _ref.className,
      _ref$renderAs = _ref.renderAs,
      renderAs = _ref$renderAs === void 0 ? 'hr' : _ref$renderAs,
      props = _objectWithoutPropertiesLoose(_ref, _excluded$V);

  return React.createElement(Element, Object.assign({}, props, {
    renderAs: renderAs,
    className: classnames('dropdown-divider', className)
  }));
};

var _excluded$W = ["className", "children", "value", "color", "align", "right", "up", "hoverable", "label", "onChange", "closeOnSelect", "icon", "domRef"];

var Dropdown = function Dropdown(_ref) {
  var className = _ref.className,
      children = _ref.children,
      value = _ref.value,
      color = _ref.color,
      align = _ref.align,
      right = _ref.right,
      up = _ref.up,
      hoverable = _ref.hoverable,
      label = _ref.label,
      onChange = _ref.onChange,
      _ref$closeOnSelect = _ref.closeOnSelect,
      closeOnSelect = _ref$closeOnSelect === void 0 ? true : _ref$closeOnSelect,
      icon = _ref.icon,
      domRef = _ref.domRef,
      props = _objectWithoutPropertiesLoose(_ref, _excluded$W);

  var ref = useRef(domRef);

  var _useState = useState(false),
      isOpen = _useState[0],
      setIsOpen = _useState[1];

  var close = function close(evt) {
    // IDK yet how to test using the ref in enzime
    // istanbul ignore if
    if (hoverable || evt && ref && ref.current && ref.current.contains(evt.target)) {
      return;
    }

    if (ref.current) {
      setIsOpen(false);
    }
  };

  var onSelect = function onSelect(selectedValue) {
    return function () {
      if (onChange) {
        onChange(selectedValue);
      }

      if (closeOnSelect) {
        close(true);
      }
    };
  };

  useEffect(function () {
    window.addEventListener('click', close);
    return function () {
      window.removeEventListener('click', close);
    };
  }, []);
  var current = label;
  var childrenArray = React.Children.map(children, function (child, i) {
    if (child.type === DropdownItem && (i === 0 && !label || child.value === value)) {
      current = child.children;
    }

    return React.cloneElement(child, child.type === DropdownItem ? {
      active: child.value === value,
      onClick: onSelect(child.value)
    } : {});
  });
  return React.createElement(Element, Object.assign({}, props, {
    domRef: ref,
    className: classnames('dropdown', className, {
      'is-active': isOpen,
      'is-up': up,
      'is-right': right || align === 'right',
      'is-hoverable': hoverable
    })
  }), React.createElement("div", {
    className: "dropdown-trigger",
    role: "presentation",
    onClick: function onClick() {
      return setIsOpen(function (o) {
        return !o;
      });
    }
  }, React.createElement(Button, {
    color: color
  }, React.createElement("span", null, current), icon)), React.createElement("div", {
    className: "dropdown-menu",
    id: "dropdown-menu",
    role: "menu"
  }, React.createElement("div", {
    className: "dropdown-content"
  }, childrenArray)));
};

Dropdown.Item = DropdownItem;
Dropdown.Divider = DropdownDivider;
var _excluded$X = ["disabled", "showFirstLast", "className", "size", "align", "rounded", "onChange", "total", "current", "delta", "next", "previous", "showPrevNext", "autoHide", "renderAs"];

var getFirstPage = function getFirstPage(current, last, delta) {
  if (current === 1) {
    return 1;
  }

  var minPage = last - delta * 2;
  var page = Math.min(current - delta, minPage);
  return page <= 0 ? 1 : page;
};

var getLastPage = function getLastPage(current, total, delta) {
  if (current === total) {
    return total;
  }

  var maxPage = delta * 2 + 1;
  var page = Math.max(current + delta, maxPage);
  return page > total ? total : page;
};

var Pagination = function Pagination(_ref) {
  var _classnames;

  var disabled = _ref.disabled,
      showFirstLast = _ref.showFirstLast,
      className = _ref.className,
      size = _ref.size,
      _ref$align = _ref.align,
      align = _ref$align === void 0 ? 'center' : _ref$align,
      rounded = _ref.rounded,
      onChange = _ref.onChange,
      _ref$total = _ref.total,
      total = _ref$total === void 0 ? 1 : _ref$total,
      _ref$current = _ref.current,
      current = _ref$current === void 0 ? 1 : _ref$current,
      _ref$delta = _ref.delta,
      delta = _ref$delta === void 0 ? 1 : _ref$delta,
      _ref$next = _ref.next,
      next = _ref$next === void 0 ? 'Next' : _ref$next,
      _ref$previous = _ref.previous,
      previous = _ref$previous === void 0 ? 'Previous' : _ref$previous,
      _ref$showPrevNext = _ref.showPrevNext,
      showPrevNext = _ref$showPrevNext === void 0 ? true : _ref$showPrevNext,
      _ref$autoHide = _ref.autoHide,
      autoHide = _ref$autoHide === void 0 ? true : _ref$autoHide,
      _ref$renderAs = _ref.renderAs,
      renderAs = _ref$renderAs === void 0 ? 'nav' : _ref$renderAs,
      props = _objectWithoutPropertiesLoose(_ref, _excluded$X);

  if (total <= 1 && autoHide || current > total) {
    return null;
  }

  var lastPage = getLastPage(current, total, delta);
  var firstPage = getFirstPage(current, lastPage, delta);
  var prevDisabled = current === 1 || disabled;
  var nextDisabled = current === total || disabled;
  return React.createElement(Element, Object.assign({}, props, {
    renderAs: renderAs,
    className: classnames('pagination', className, (_classnames = {}, _classnames["is-" + size] = size, _classnames["is-" + normalizeAlign(align)] = align, _classnames['is-rounded'] = rounded, _classnames)),
    "aria-label": "pagination"
  }), showPrevNext && React.createElement(React.Fragment, null, React.createElement("a", {
    role: "button",
    tabIndex: 0,
    onClick: prevDisabled ? undefined : function () {
      return onChange(current - 1);
    },
    className: "pagination-previous",
    title: "This is the first page",
    "data-disabled": prevDisabled
  }, previous), React.createElement("a", {
    role: "button",
    tabIndex: 0,
    onClick: nextDisabled ? undefined : function () {
      return onChange(current + 1);
    },
    className: "pagination-next",
    "data-disabled": nextDisabled
  }, next)), delta > 0 && React.createElement(React.Fragment, null, React.createElement("ul", {
    className: "pagination-list"
  }, showFirstLast && current !== 1 && firstPage !== 1 && React.createElement(React.Fragment, null, React.createElement("li", {
    key: 1
  }, React.createElement("a", {
    role: "button",
    tabIndex: 0,
    className: "pagination-link",
    onClick: function onClick() {
      return onChange(1);
    },
    "aria-label": "Page 1",
    "aria-current": "page",
    "data-disabled": disabled
  }, "1")), React.createElement("li", null, React.createElement("span", {
    className: "pagination-ellipsis"
  }, "\u2026"))), Array(lastPage - firstPage + 1).fill(0).map(function (_, i) {
    return React.createElement("li", {
      key: i + firstPage
    }, React.createElement("a", {
      role: "button",
      tabIndex: 0,
      className: classnames('pagination-link', {
        'is-current': current === i + firstPage
      }),
      onClick: current === firstPage + i ? undefined : function () {
        return onChange(firstPage + i);
      },
      "aria-label": "Page " + (i + firstPage),
      "aria-current": "page",
      "data-disabled": disabled
    }, i + firstPage));
  }), showFirstLast && current !== lastPage && total !== lastPage && React.createElement(React.Fragment, null, React.createElement("li", {
    key: total
  }, React.createElement("span", {
    className: "pagination-ellipsis"
  }, "\u2026")), React.createElement("li", null, React.createElement("a", {
    role: "button",
    tabIndex: 0,
    className: "pagination-link",
    onClick: function onClick() {
      return onChange(total);
    },
    "aria-label": "Page " + total,
    "aria-current": "page",
    "data-disabled": disabled
  }, total))))));
};

var _excluded$Y = ["children", "className", "style", "active", "domRef", "renderAs"];

var Tab = function Tab(_ref) {
  var children = _ref.children,
      className = _ref.className,
      style = _ref.style,
      active = _ref.active,
      domRef = _ref.domRef,
      _ref$renderAs = _ref.renderAs,
      renderAs = _ref$renderAs === void 0 ? 'a' : _ref$renderAs,
      props = _objectWithoutPropertiesLoose(_ref, _excluded$Y);

  return React.createElement("li", {
    "data-ref": domRef,
    style: style,
    className: classnames(className, {
      'is-active': active
    })
  }, React.createElement(Element, Object.assign({}, props, {
    renderAs: renderAs
  }), children));
};

var _excluded$Z = ["children", "className", "align", "size", "type", "fullwidth"];

var Tabs = function Tabs(_ref) {
  var _classnames;

  var children = _ref.children,
      className = _ref.className,
      _ref$align = _ref.align,
      align = _ref$align === void 0 ? 'center' : _ref$align,
      size = _ref.size,
      type = _ref.type,
      fullwidth = _ref.fullwidth,
      props = _objectWithoutPropertiesLoose(_ref, _excluded$Z);

  return React.createElement(Element, Object.assign({}, props, {
    className: classnames('tabs', className, (_classnames = {}, _classnames["is-" + normalizeAlign(align)] = align, _classnames["is-" + size] = size, _classnames['is-toggle'] = type === 'toggle-rounded', _classnames["is-" + type] = type, _classnames['is-fullwidth'] = fullwidth, _classnames))
  }), React.createElement("ul", null, children));
};

Tabs.Tab = Tab;
var _excluded$_ = ["className", "children"];

var NavbarBrand = function NavbarBrand(_ref) {
  var className = _ref.className,
      children = _ref.children,
      props = _objectWithoutPropertiesLoose(_ref, _excluded$_);

  return React.createElement(Element, Object.assign({}, props, {
    className: classnames('navbar-brand', className)
  }), children);
};

var ShowContext = /*#__PURE__*/React.createContext(false);
var _excluded$$ = ["style", "className"];

var NavbarBurger = function NavbarBurger(_ref) {
  var style = _ref.style,
      className = _ref.className,
      props = _objectWithoutPropertiesLoose(_ref, _excluded$$);

  return React.createElement(ShowContext.Consumer, null, function (active) {
    return React.createElement(Element, Object.assign({
      role: "button",
      tabIndex: 0,
      style: _extends({
        outline: 'none'
      }, style),
      className: classnames('navbar-burger', className, {
        'is-active': active
      })
    }, props), React.createElement("span", null), React.createElement("span", null), React.createElement("span", null));
  });
};

var _excluded$10 = ["className", "children"];

var NavbarMenu = function NavbarMenu(_ref) {
  var className = _ref.className,
      children = _ref.children,
      props = _objectWithoutPropertiesLoose(_ref, _excluded$10);

  return React.createElement(ShowContext.Consumer, null, function (active) {
    return React.createElement(Element, Object.assign({}, props, {
      className: classnames('navbar-menu', className, {
        'is-active': active
      })
    }), children);
  });
};

var _excluded$11 = ["className", "boxed", "right", "children", "up", "renderAs"];

var NavbarDropdown = function NavbarDropdown(_ref) {
  var className = _ref.className,
      boxed = _ref.boxed,
      right = _ref.right,
      children = _ref.children,
      _ref$renderAs = _ref.renderAs,
      renderAs = _ref$renderAs === void 0 ? 'span' : _ref$renderAs,
      props = _objectWithoutPropertiesLoose(_ref, _excluded$11);

  return React.createElement(Element, Object.assign({}, props, {
    renderAs: renderAs,
    className: classnames('navbar-dropdown', className, {
      'is-boxed': boxed,
      'is-right': right
    })
  }), children);
};

var _excluded$12 = ["className", "active", "children", "hoverable", "arrowless", "up", "href", "renderAs"];

var NavbarItem = function NavbarItem(_ref) {
  var className = _ref.className,
      active = _ref.active,
      children = _ref.children,
      hoverable = _ref.hoverable,
      arrowless = _ref.arrowless,
      href = _ref.href,
      _ref$renderAs = _ref.renderAs,
      renderAs = _ref$renderAs === void 0 ? 'a' : _ref$renderAs,
      props = _objectWithoutPropertiesLoose(_ref, _excluded$12);

  var as = renderAs;
  var dropdown = React.Children.toArray(children).find(function (child) {
    return child.type === NavbarDropdown;
  });

  if (dropdown && renderAs === 'a') {
    as = 'span';
  }

  return React.createElement(Element, Object.assign({}, props, {
    href: href,
    renderAs: as,
    className: classnames('navbar-item', className, {
      'is-active': active,
      'has-dropdown': dropdown,
      'is-hoverable': hoverable,
      // 'has-dropdown-up': dropdown,
      'has-dropdown-up': dropdown && dropdown.up,
      'is-arrowless': arrowless
    })
  }), children);
};

var _excluded$13 = ["className", "renderAs"];

var NavbarDivider = function NavbarDivider(_ref) {
  var className = _ref.className,
      _ref$renderAs = _ref.renderAs,
      renderAs = _ref$renderAs === void 0 ? 'hr' : _ref$renderAs,
      props = _objectWithoutPropertiesLoose(_ref, _excluded$13);

  return React.createElement(Element, Object.assign({}, props, {
    renderAs: renderAs,
    className: classnames('navbar-divider', className)
  }));
};

var _excluded$14 = ["className", "children", "arrowless", "renderAs"];

var NavbarLink = function NavbarLink(_ref) {
  var className = _ref.className,
      children = _ref.children,
      arrowless = _ref.arrowless,
      _ref$renderAs = _ref.renderAs,
      renderAs = _ref$renderAs === void 0 ? 'span' : _ref$renderAs,
      props = _objectWithoutPropertiesLoose(_ref, _excluded$14);

  return React.createElement(Element, Object.assign({}, props, {
    renderAs: renderAs,
    className: classnames('navbar-link', className, {
      'is-arrowless': arrowless
    })
  }), children);
};

var _excluded$15 = ["className", "children", "align"];
var alignMapper = {
  left: 'start',
  right: 'end'
};

var NavbarContainer = function NavbarContainer(_ref) {
  var _classnames;

  var className = _ref.className,
      children = _ref.children,
      _ref$align = _ref.align,
      align = _ref$align === void 0 ? 'left' : _ref$align,
      props = _objectWithoutPropertiesLoose(_ref, _excluded$15);

  return React.createElement(Element, Object.assign({}, props, {
    className: classnames((_classnames = {}, _classnames["navbar-" + alignMapper[align]] = alignMapper[align], _classnames), className)
  }), children);
};

var _excluded$16 = ["children", "className", "fixed", "transparent", "color", "active", "size", "renderAs"];

var Navbar = function Navbar(_ref) {
  var _classnames;

  var children = _ref.children,
      className = _ref.className,
      fixed = _ref.fixed,
      transparent = _ref.transparent,
      color = _ref.color,
      _ref$active = _ref.active,
      active = _ref$active === void 0 ? false : _ref$active,
      size = _ref.size,
      _ref$renderAs = _ref.renderAs,
      renderAs = _ref$renderAs === void 0 ? 'nav' : _ref$renderAs,
      props = _objectWithoutPropertiesLoose(_ref, _excluded$16);

  useEffect(function () {
    var html = window.document.querySelector('html');

    if (!html.classList.contains("has-navbar-fixed-" + fixed)) {
      html.classList.remove('has-navbar-fixed-top');
      html.classList.remove('has-navbar-fixed-bottom');
    }

    if (fixed) {
      html.classList.add("has-navbar-fixed-" + fixed);
    }

    return function () {
      return html.classList.remove("has-navbar-fixed-" + fixed);
    };
  }, [fixed]);
  return React.createElement(ShowContext.Provider, {
    value: active
  }, React.createElement(Element, Object.assign({}, props, {
    renderAs: renderAs,
    role: "navigation",
    className: classnames('navbar', className, (_classnames = {
      'is-transparent': transparent
    }, _classnames["is-fixed-" + fixed] = fixed, _classnames["is-" + color] = color, _classnames["is-spaced"] = size === 'large', _classnames))
  }), children));
};

Navbar.Brand = NavbarBrand;
Navbar.Burger = NavbarBurger;
Navbar.Menu = NavbarMenu;
Navbar.Item = NavbarItem;
Navbar.Dropdown = NavbarDropdown;
Navbar.Link = NavbarLink;
Navbar.Divider = NavbarDivider;
Navbar.Container = NavbarContainer;
var _excluded$17 = ["className", "active"];

var PanelBlock = function PanelBlock(_ref) {
  var className = _ref.className,
      active = _ref.active,
      props = _objectWithoutPropertiesLoose(_ref, _excluded$17);

  return React.createElement(Element, Object.assign({}, props, {
    className: classnames('panel-block', className, {
      'is-active': active
    })
  }));
};

var _excluded$18 = ["className"];

var PanelHeader = function PanelHeader(_ref) {
  var className = _ref.className,
      props = _objectWithoutPropertiesLoose(_ref, _excluded$18);

  return React.createElement(Element, Object.assign({}, props, {
    className: classnames('panel-heading', className)
  }));
};

var _excluded$19 = ["className", "renderAs"];

var PanelIcon = function PanelIcon(_ref) {
  var className = _ref.className,
      _ref$renderAs = _ref.renderAs,
      renderAs = _ref$renderAs === void 0 ? 'span' : _ref$renderAs,
      props = _objectWithoutPropertiesLoose(_ref, _excluded$19);

  return React.createElement(Element, Object.assign({
    renderAs: renderAs
  }, props, {
    className: classnames('panel-icon', className)
  }));
};

var _excluded$1a = ["className", "active", "renderAs"];

var PanelTabsTab = function PanelTabsTab(_ref) {
  var className = _ref.className,
      active = _ref.active,
      _ref$renderAs = _ref.renderAs,
      renderAs = _ref$renderAs === void 0 ? 'a' : _ref$renderAs,
      props = _objectWithoutPropertiesLoose(_ref, _excluded$1a);

  return React.createElement(Element, Object.assign({}, props, {
    renderAs: renderAs,
    className: classnames(className, {
      'is-active': active
    })
  }));
};

var _excluded$1b = ["className"];

var PanelTabs = function PanelTabs(_ref) {
  var className = _ref.className,
      props = _objectWithoutPropertiesLoose(_ref, _excluded$1b);

  return React.createElement(Element, Object.assign({}, props, {
    className: classnames('panel-tabs', className)
  }));
};

PanelTabs.Tab = PanelTabsTab;
var _excluded$1c = ["color", "renderAs", "className"];

var Panel = function Panel(_ref) {
  var _classnames;

  var color = _ref.color,
      _ref$renderAs = _ref.renderAs,
      renderAs = _ref$renderAs === void 0 ? 'nav' : _ref$renderAs,
      className = _ref.className,
      props = _objectWithoutPropertiesLoose(_ref, _excluded$1c);

  return React.createElement(Element, Object.assign({}, props, {
    renderAs: renderAs,
    className: classnames('panel', className, (_classnames = {}, _classnames["is-" + color] = color, _classnames))
  }));
};

Panel.Header = PanelHeader;
Panel.Tabs = PanelTabs;
Panel.Block = PanelBlock;
Panel.Icon = PanelIcon;
var _excluded$1d = ["className", "active", "children", "renderAs"];

var BreadcrumbItem = function BreadcrumbItem(_ref) {
  var className = _ref.className,
      active = _ref.active,
      children = _ref.children,
      _ref$renderAs = _ref.renderAs,
      renderAs = _ref$renderAs === void 0 ? 'li' : _ref$renderAs,
      props = _objectWithoutPropertiesLoose(_ref, _excluded$1d);

  return React.createElement(Element, Object.assign({}, props, {
    renderAs: renderAs,
    className: classnames(className, {
      'is-active': active
    })
  }), children);
};

var _excluded$1e = ["className", "separator", "size", "align", "children", "renderAs"];

var Breadcrumb = function Breadcrumb(_ref) {
  var _classnames;

  var className = _ref.className,
      separator = _ref.separator,
      size = _ref.size,
      align = _ref.align,
      children = _ref.children,
      _ref$renderAs = _ref.renderAs,
      renderAs = _ref$renderAs === void 0 ? 'nav' : _ref$renderAs,
      props = _objectWithoutPropertiesLoose(_ref, _excluded$1e);

  return React.createElement(Element, Object.assign({}, props, {
    renderAs: renderAs,
    className: classnames('breadcrumb', className, (_classnames = {}, _classnames["has-" + separator + "-separator"] = separator, _classnames["is-" + size] = size, _classnames["is-" + align] = align, _classnames))
  }), React.createElement("ul", null, children));
};

Breadcrumb.Item = BreadcrumbItem;
var _excluded$1f = ["children", "className", "size"];

var Content = function Content(_ref) {
  var _classnames;

  var children = _ref.children,
      className = _ref.className,
      size = _ref.size,
      props = _objectWithoutPropertiesLoose(_ref, _excluded$1f);

  return React.createElement(Element, Object.assign({}, props, {
    className: classnames('content', className, (_classnames = {}, _classnames["is-" + size] = size, _classnames))
  }), children);
};

var _excluded$1g = ["className", "size", "renderAs"];

var Delete = function Delete(_ref) {
  var _classnames;

  var className = _ref.className,
      size = _ref.size,
      _ref$renderAs = _ref.renderAs,
      renderAs = _ref$renderAs === void 0 ? 'button' : _ref$renderAs,
      props = _objectWithoutPropertiesLoose(_ref, _excluded$1g);

  return React.createElement(Element, Object.assign({}, props, {
    renderAs: renderAs,
    className: classnames('delete', className, (_classnames = {}, _classnames["is-" + size] = size, _classnames))
  }));
};

var _excluded$1h = ["size", "color", "className", "align", "text"];

var Icon = function Icon(_ref) {
  var _classnames;

  var size = _ref.size,
      color = _ref.color,
      className = _ref.className,
      align = _ref.align,
      text = _ref.text,
      props = _objectWithoutPropertiesLoose(_ref, _excluded$1h);

  return React.createElement(Element, Object.assign({}, props, {
    className: classnames('icon', className, (_classnames = {}, _classnames["is-" + size] = size, _classnames["is-" + align] = align, _classnames["has-text-" + color] = color, _classnames['icon-text'] = text, _classnames))
  }));
};

var _excluded$1i = ["className"];

var TableContainer = function TableContainer(_ref) {
  var className = _ref.className,
      props = _objectWithoutPropertiesLoose(_ref, _excluded$1i);

  return React.createElement(Element, Object.assign({}, props, {
    className: classnames('table-container', className)
  }));
};

var _excluded$1j = ["children", "className", "size", "striped", "bordered", "hoverable"];

var Table = function Table(_ref) {
  var _classnames;

  var children = _ref.children,
      className = _ref.className,
      size = _ref.size,
      striped = _ref.striped,
      bordered = _ref.bordered,
      hoverable = _ref.hoverable,
      props = _objectWithoutPropertiesLoose(_ref, _excluded$1j);

  return React.createElement(Element, Object.assign({}, props, {
    renderAs: "table",
    className: classnames('table', className, (_classnames = {}, _classnames["is-" + size] = size, _classnames['is-bordered'] = bordered, _classnames['is-striped'] = striped, _classnames['is-hoverable'] = hoverable, _classnames))
  }), children);
};

Table.Container = TableContainer;
var _excluded$1k = ["children", "className", "gapless", "hasAddons", "renderAs"];

var TagGroup = function TagGroup(_ref) {
  var children = _ref.children,
      className = _ref.className,
      gapless = _ref.gapless,
      hasAddons = _ref.hasAddons,
      props = _objectWithoutPropertiesLoose(_ref, _excluded$1k);

  return React.createElement(Element, Object.assign({}, props, {
    className: classnames('tags', className, {
      'has-addons': gapless || hasAddons
    })
  }), children);
};

var _excluded$1l = ["children", "className", "color", "size", "rounded", "remove", "renderAs"];

var Tag = function Tag(_ref) {
  var _classnames;

  var children = _ref.children,
      className = _ref.className,
      color = _ref.color,
      size = _ref.size,
      rounded = _ref.rounded,
      remove = _ref.remove,
      props = _objectWithoutPropertiesLoose(_ref, _excluded$1l);

  return React.createElement(Element, Object.assign({}, props, {
    className: classnames('tag', className, (_classnames = {}, _classnames["is-" + size] = size, _classnames["is-" + color] = color, _classnames['is-rounded'] = rounded, _classnames['is-delete'] = remove, _classnames))
  }), !remove && children);
};

Tag.Group = TagGroup;
var _excluded$1m = ["children", "className", "spaced", "renderAs", "size"];

var Title = function Title(_ref) {
  var _classnames;

  var children = _ref.children,
      className = _ref.className,
      spaced = _ref.spaced,
      _ref$renderAs = _ref.renderAs,
      renderAs = _ref$renderAs === void 0 ? 'h3' : _ref$renderAs,
      _ref$size = _ref.size,
      size = _ref$size === void 0 ? 3 : _ref$size,
      props = _objectWithoutPropertiesLoose(_ref, _excluded$1m);

  return React.createElement(Element, Object.assign({}, props, {
    renderAs: renderAs,
    className: classnames('title', className, (_classnames = {}, _classnames["is-" + size] = size, _classnames["is-" + spaced] = spaced, _classnames))
  }), children);
};

var _excluded$1n = ["children", "className", "spaced", "size", "renderAs"];

var SubTitle = function SubTitle(_ref) {
  var _classnames;

  var children = _ref.children,
      className = _ref.className,
      spaced = _ref.spaced,
      _ref$size = _ref.size,
      size = _ref$size === void 0 ? 5 : _ref$size,
      _ref$renderAs = _ref.renderAs,
      renderAs = _ref$renderAs === void 0 ? 'h5' : _ref$renderAs,
      props = _objectWithoutPropertiesLoose(_ref, _excluded$1n);

  return React.createElement(Element, Object.assign({}, props, {
    renderAs: renderAs,
    className: classnames('subtitle', className, (_classnames = {}, _classnames["is-" + size] = size, _classnames["is-" + spaced] = spaced, _classnames))
  }), children);
};

export { Block, Box, Breadcrumb, Button, Card, Column, Columns, Container, Content, Delete, Dropdown, Footer, index as Form, Hero, Icon, Image, Level, Media, Menu, Message, Modal, Navbar, Notification, Pagination, Panel, Progress, Section, SubTitle, Table, Tabs, Tag, Tile, Title };